import {combineEpics} from 'redux-observable';
import breakEpics from 'pages/EditBreak/epics.js';
import listPrizesEpics from 'pages/ListPrizes/epics';
import editPrizeEpics from 'pages/EditPrize/epics.js';
import listWinnersEpics from 'pages/ListWinners/epics';
import listEntriesEpics from 'pages/ListEntries/epics';
import multipleWinnersEpics from 'pages/MultipleWinners/epics';
import viewAllEpics from 'pages/ViewAllPlatforms/epics';
import imagesEpic from 'pages/Images/epics';
import rewardsEpic from 'pages/Rewards/epics';
import profileEpics from 'pages/Profile/epics';
import resourceEpics from 'resources/epics';
import userEpics from 'pages/Login/epics';
import masterSearchEpics from 'components/MasterSearchBar/epics';
import createChallengeEpics from 'pages/BreakCreator/epics';
import ugcModerationEpics from 'pages/UGCModeration/epics';
import createPrizeEpics from 'pages/PrizeCreator/epics';
import copyChallengeEpics from 'pages/BreakCopy/epics';
import copyPrizeEpics from 'pages/PrizeCopy/epics';
import userManagementEpics from 'pages/UserManagement/epics';
import deleteBreakEpics from 'pages/DeleteConfirmation/epics';
import publishValidateChallengeEpics from 'pages/BreakPublish/epics';
import leadGenPickerEpics from 'pages/LeadGenFieldPicker/epics';
import storeFinderImportEpics from 'pages/StoreFinderImport/epics';
import homepageItemEpics from 'components/homepage-layouts/items/AddItemModal/epics';
import breakTagModalEpics from "pages/EditBreak/BreakTagModal/epics";
import deleteBreakTagModalEpics from 'pages/EditBreak/DeleteBreakTagModal/epics';
import {epics as relatedBreakEditorEpics} from "pages/RelatedBreakEditor/reducer";

export const rootEpic = combineEpics(
    ...breakEpics,
    ...listPrizesEpics,
    ...editPrizeEpics,
    ...listWinnersEpics,
    ...listEntriesEpics,
    ...multipleWinnersEpics,
    ...createPrizeEpics,
    ...viewAllEpics,
    ...createChallengeEpics,
    ...ugcModerationEpics,
    ...copyChallengeEpics,
    ...copyPrizeEpics,
    ...userManagementEpics,
    ...imagesEpic,
    ...rewardsEpic,
    ...profileEpics,
    ...publishValidateChallengeEpics,
    ...resourceEpics,
    ...masterSearchEpics,
    ...userEpics,
    ...deleteBreakEpics,
    ...leadGenPickerEpics,
    ...storeFinderImportEpics,
    ...homepageItemEpics,
    ...breakTagModalEpics,
    ...deleteBreakTagModalEpics,
    ...relatedBreakEditorEpics
);



// WEBPACK FOOTER //
// ./public/rootEpic.js